import { styled } from '@mui/material/styles';
import { Switch } from '@mui/material';

// Same switch as investor-web's Auto-Shortlist toggle (its ui-components/CustomSwitch.js).
const BRAND_GRADIENT = 'linear-gradient(135deg,#7852f8,#84aef6)';
const BRAND_GRADIENT_BORDER =
  'linear-gradient(#FFFFFF, #FFFFFF), linear-gradient(135deg, #7852F8 0%, #84AEF6 100%)';

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 38,
  height: 20,
  padding: 0,
  display: 'flex',
  flexShrink: 0,
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 20,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(14px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: '#fff',
      '& .MuiSwitch-thumb': {
        backgroundColor: '#fff',
        backgroundImage: 'none',
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundImage: BRAND_GRADIENT,
        backgroundClip: 'border-box',
        backgroundColor: 'transparent',
      },
    },
  },
  '& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track': {
    opacity: 0.5,
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 16,
    height: 16,
    borderRadius: 8,
    backgroundImage: BRAND_GRADIENT,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 20 / 2,
    opacity: 1,
    border: '1.5px solid transparent',
    backgroundImage: BRAND_GRADIENT_BORDER,
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box',
    boxSizing: 'border-box',
  },
}));

export default CustomSwitch;
